import { combineValidators } from "revalidate";
import { emailFieldValidator, passwordFieldValidator } from "app/utils/form/fieldValidators";

export const fields = ["email", "password"];

export const validate = combineValidators({
	email: emailFieldValidator,
	password: passwordFieldValidator,
});
